import template from './template.html'
import controller from './kickerAdmin.controller'

export default {
  restrict: 'E',
  template,
  bindings: {
    labelsCfg: '<',
    getLabels: '<', // because we want to pass a reference to these callbacks,
    setLabels: '<', // use '<', as '&' evaluates inline expressions
  },
  controller,
  controllerAs: 'vm',
}
